import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
// Constants
import constants from "./constants/http-status.constants";
var isSuccessStatus = function isSuccessStatus(status) {
  return constants.SUCCESS.includes(status);
};
var isUnauthorizedStatus = function isUnauthorizedStatus(status) {
  return constants.NO_AUTHORIZED === status;
};
var isNoResultsFoundStatus = function isNoResultsFoundStatus(status) {
  return constants.NO_RESULTS === status;
};
var isOtpFlowDemand = function isOtpFlowDemand(_ref) {
  var response = _ref.response,
    status = _ref.status;
  return !!(constants.FORBIDDEN === status && response !== null && response !== void 0 && response.otpId && response !== null && response !== void 0 && response.progressId);
};
export default {
  isNoResultsFoundStatus: isNoResultsFoundStatus,
  isOtpFlowDemand: isOtpFlowDemand,
  isSuccessStatus: isSuccessStatus,
  isUnauthorizedStatus: isUnauthorizedStatus
};